import {
  Legacyprofile,
  CompactProfileList as CompactProfileListData,
  Publicprofile,
} from '@/payload-types'
import LegacyCompactPostProfileCard from '@/components/legacy-profile-profile-card/compactPostProfileCard'
import { SortProfileListAlphabetically } from '@/lib/profileFunction'
import CompactPostProfileCard from '../public-profile-card/compactPostProfileCard'
interface IProps {
  profileListData: CompactProfileListData | null
}

export const CompactProfileList = ({ profileListData }: IProps) => {
  if (profileListData?.hasManyProfileList) {
    const sortedProdileList = SortProfileListAlphabetically(profileListData)
    return (
      <div>
        <div className="flex flex-wrap justify-center mr-[-5.5px]">
          {sortedProdileList?.map((item, index) => {
            if (item.relationTo === 'publicprofiles') {
              return (
                <CompactPostProfileCard profileData={item.value as Publicprofile} key={index} />
              )
            } else {
              return (
                <LegacyCompactPostProfileCard
                  profileData={item.value as Legacyprofile}
                  key={index}
                />
              )
            }
          })}
        </div>
      </div>
    )
  }
}

export default CompactProfileList
